import React from 'react';
import { cn } from './cn';

type BadgeTone = 'neutral' | 'primary' | 'success' | 'warning' | 'danger' | 'navy';

const tones: Record<BadgeTone, string> = {
  neutral: 'bg-ds-subtle text-ds-700',
  primary: 'bg-ds-primary-soft text-ds-primary-strong',
  success: 'bg-ds-success-soft text-ds-success',
  warning: 'bg-ds-warning-soft text-ds-800',
  danger: 'bg-ds-danger-soft text-ds-danger',
  navy: 'bg-ds-navy-soft text-ds-navy',
};

export function Badge({ className, tone = 'neutral', ...props }: React.HTMLAttributes<HTMLSpanElement> & { tone?: BadgeTone }) {
  return <span className={cn('inline-flex items-center rounded-ds-8 px-2 py-1 text-[10px] font-bold', tones[tone], className)} {...props} />;
}
